import React from "react";

import { DateHeader, ExpertSideMessage, UserSideMessage } from ".";
import { AppAuthRoles } from "../../../config/app-constants";
import { IEfilingMessage } from "../../../config/interfaces";

type Props = {
  messages: IEfilingMessage[];
};

const ChatContainerBody: React.FC<Props> = (props: Props) => {
  const { messages } = props;

  return (
    <div className="msgs-wrap">
      {messages &&
        messages?.map((msg, index) => {
          return (
            <React.Fragment key={`message-${msg.id}`}>
              <DateHeader
                currentMsgId={msg.id}
                lastMsgId={messages[index ? index - 1 : index].id}
                currentMsgDate={msg?.createdAt}
                lastMsgDate={messages[index ? index - 1 : index].createdAt}
              />
              {msg?.efilingMessageCreatedBy?.role === AppAuthRoles.CA ? (
                <ExpertSideMessage message={msg} />
              ) : (
                <UserSideMessage message={msg} />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default ChatContainerBody;
